import {Map} from "immutable";

export function isSubmitting(info = Map()) {
  return info.get("status", "") === "submitting";
}

export function submitLabel(info = Map(), defaultLabel="Submit") {
  if (isSubmitting(info)) return "Submitting...";
  return defaultLabel;
}

export function hasErrors(info = Map()) {
  return info.get("status", "") === "failed";
}

// export function 